import { getAllPricePlans } from '@/lib/pricing/price-plan';
import { PaymentTypes, type PricePlan } from '@/payment/types';
import type { BillingState } from './billing-state';

function getSubscriptionTierCredits(plan: PricePlan | null): number | null {
  const credits = plan?.credits;
  if (
    !credits?.enable ||
    !Number.isFinite(credits.amount) ||
    credits.amount <= 0
  ) {
    return null;
  }

  return credits.amount;
}

function isPurchasableSubscriptionPlan(plan: PricePlan): boolean {
  return (
    !plan.isFree &&
    !plan.disabled &&
    plan.prices.some(
      (price) =>
        price.type === PaymentTypes.SUBSCRIPTION && price.disabled !== true
    )
  );
}

export function isHighestSubscriptionTier(
  billingState: Pick<BillingState, 'billingMode' | 'currentPlan'>,
  plans: PricePlan[] = getAllPricePlans()
): boolean {
  if (billingState.billingMode !== 'subscription') {
    return false;
  }

  const currentTierCredits = getSubscriptionTierCredits(
    billingState.currentPlan
  );
  if (currentTierCredits === null) {
    return false;
  }

  const purchasableTierCredits = plans
    .filter(isPurchasableSubscriptionPlan)
    .map(getSubscriptionTierCredits)
    .filter((credits): credits is number => credits !== null);
  if (purchasableTierCredits.length === 0) {
    return false;
  }

  return currentTierCredits >= Math.max(...purchasableTierCredits);
}
